import {AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';
import {newGuid, getParam} from '../question-helper';
import {GlobalQuestionService} from '../../services/global-question.service';
import { Alert } from '../../utilities';

@Component({
    selector: 'app-question-textbox',
    templateUrl: './question-textbox.component.html',
    styleUrls: ['./question-textbox.component.scss'],
    standalone: false
})
export class QuestionTextboxComponent implements OnInit, AfterViewInit, OnChanges {

  @Input() question: Question;
  @Input() readOnly = false;
  @Input() showLabel = true;
  @Input() labelText = '';
  @Input() placeHolderText = '';
  @Input() value = '';
  @Input() inputType = 'text';
  @Input() isIdInput = false;
  @Input() editModal = false;
  @Input() showToolTip = false;
  @Input() toolTipContent = 'To change this answer you need to restart or contact us';
  @Input() toolTipPlacement = 'bottom';
  @Input() isToolTipContentHtml = false;
  @Output() questionAnswer = new EventEmitter();

  uniqueControlName = `textbox-${newGuid()}`;
  uniqueId = `textbox-${newGuid()}`;
  idValid = true;
  skipped = false;
  showSkip = false;
  parameter: any;
  constructor(private questionService: GlobalQuestionService) {
    
  }

  ngOnInit(): void {
    try {
      this.parameter = JSON.parse(this.question.parameter);
    } catch (e) { }
    if (getParam(this.parameter, 'show_skip')?.value === '1') {
      this.showSkip = true;
    }
    if (this.question?.answer) {
      this.value = this.question?.answer;
    } else {
      if (this.question?.answer === ''){
        this.value = ''; 
      } 
    }
  }

  ngOnChanges(): void {
    if (this.question?.answer) {
      this.value = this.question?.answer;
    } else {
      if (this.question?.answer === ''){
        this.value = ''; 
      } 
    }
    setTimeout(() => {
      this.questionService.initPopoverCustomize();
    }, 1000);
  }

  ngAfterViewInit(): void {
    if (this.showToolTip) {
      this.questionService.initPopoverCustomize();
    }
  }

  noregNumber(): void {
    this.value = 'TBC ' + this.question?.item_id;
    this.saveValue();
  }

  upperCase(): void {
    if (this.question?.cent_aq_question_id === 57 || this.question?.cent_aq_question_id === 2501) {
      this.value = this.value.toUpperCase();
    }
  }
  onSkipChange(): void {
    if (this.skipped) {
      this.question.answer = 'skipped';
    } else {
      this.question.answer = '';
    }
    this.questionAnswer.emit(this.question);
  }
  saveValue(): void {
    // finding_id 54: strip HTML tag delimiters at the source so free-text answers (name,
    // surname, etc.) can't carry markup into any downstream display that later reflects them.
    if (this.value) {
      this.value = this.value.replace(/[<>]/g, '');
    }
    if (this.isIdInput) {
      if (this.validateIdNumber(this.value)) {
        if (this.question) {
          this.question.answer = this.value;
          this.questionAnswer.emit(this.question);
        } else {
          this.questionAnswer.emit(this.value);
        }
      } else {
        //Alert("ID Number invalid")
        this.question.answer = '';
        this.questionAnswer.emit(this.question);
      }
    } else {
      if (this.question?.cent_aq_question_id === 57 || this.question?.cent_aq_question_id === 2501) {
        this.value = this.value.toUpperCase();
      }
      if (this.question) {
        this.question.answer = this.value;
        this.questionAnswer.emit(this.question);
      } else {
        this.questionAnswer.emit(this.value);
      }
    }
  }

  validateIdNumber(value: any): boolean {
    const regex = new RegExp(/^(((\d{2}((0[13578]|1[02])(0[1-9]|[12]\d|3[01])|(0[13456789]|1[012])(0[1-9]|[12]\d|30)|02(0[1-9]|1\d|2[0-8])))|([02468][048]|[13579][26])0229))(( |-)(\d{4})( |-)(\d{3})|(\d{7}))/);
    // apply Luhn formula for check-digits
    let tempTotal = 0;
    let checkSum = 0;
    let multiplier = 1;
    if (value?.length > 13) {
      this.idValid = false;
      return false;
    }
    for (let i = 0; i < 13; ++i) {
      tempTotal = (+value.charAt(i)) * multiplier;
      if (tempTotal > 9) {
        tempTotal = (+tempTotal.toString().charAt(0)) + (+tempTotal.toString().charAt(1));
      }
      checkSum = checkSum + tempTotal;
      multiplier = (multiplier % 2 === 0) ? 1 : 2;
    }
    if ((checkSum % 10) !== 0) {
      this.idValid = false;
      return false;
    }
    this.idValid = true;
    return regex.test(value);
  }

}
